import { Link } from "react-router-dom";

interface Props extends React.PropsWithChildren {
  title: string;
  description?: string;
  icon: string;
  link?: string;
  color: string;
  className?: string;
  onClick?(): void;
  description_ltr?: boolean;
  noArrow?: boolean;
}
export const SupportItem: React.FC<Props> = ({
  className,
  title,
  description,
  icon,
  link,
  color,
  onClick,
  description_ltr,
  noArrow = false,
  children,
}) => {
  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    if (onClick) {
      onClick();
    }
    if (!link) {
      event.preventDefault();
    }
  };
  const isExternalLink = link && (link.startsWith("http") || link.startsWith("tel:"));

  const content = (
    <div className={`bg-white rounded-md shadow cursor-pointer ${className}`} onClick={handleClick}>
      <div className="flex items-center px-4 py-2 h-[74px]">
        <div className={`flex mx-auto items-center justify-center bg-pkc-${color}-15 btn-circle`}>
          <i className={`${icon} my-auto text-pkc-${color}`} />
        </div>
        <div className="flex flex-col justify-center flex-1 pr-3 mr-auto">
          <p className={`pb-2 text-pkc-${color}`}>{title}</p>
          <p
            style={{ direction: description_ltr ? "ltr" : "rtl" }}
            className="text-xs text-right text-gray-600 sm:text-sm"
          >
            {description}
          </p>
        </div>
        {!noArrow && <i className="my-auto text-gray-600 fas fa-chevron-left" />}
      </div>
      {children}
    </div>
  );

  return link ? (
    isExternalLink ? (
      <a href={link} target="_blank" rel="noopener noreferrer">
        {content}
      </a>
    ) : (
      <Link to={link}>{content}</Link>
    )
  ) : (
    content
  );
};

export default SupportItem;
